import React from "react";

import classnames from "classnames";
import styles from "./Category.local.scss";

const CategoryFetching = () => (
  <div className={styles["category-fetching"]}>
    <div className={classnames(styles.brunch, styles.root)} />
    <ul className={styles.child}>
      <li>
        <div className={classnames(styles.brunch, styles.layer)} />
        <ul className={styles.child}>
          <li>
            <div className={classnames(styles.brunch, styles.layer)} />
          </li>
          <li>
            <div className={classnames(styles.brunch, styles.layer)} />
          </li>
        </ul>
      </li>
      <li>
        <div className={classnames(styles.brunch, styles.layer)} />
      </li>
    </ul>
  </div>
);

export default CategoryFetching;



// WEBPACK FOOTER //
// ./src/components/CategoriesList/CategoryFetching/CategoryFetching.js